import type { CellObject, Options } from 'write-excel-file/universal';

/* eslint-disable no-restricted-syntax -- стили ячеек книги Excel, а не CSS: токены типографики к ним не относятся */
/** Шрифт книги, как у Excel по умолчанию: без него Excel и LibreOffice подставляют каждый свой. */
export const XLSX_FONT: Options<Blob> = { fontFamily: 'Calibri', fontSize: 11 };
export const XLSX_BOLD = { fontWeight: 'bold' } as const satisfies CellObject;
/* eslint-enable no-restricted-syntax */

const SHEET_NAME_MAX = 31;

/** Имя листа, которое примет Excel: без `[]:*?/\` и апострофов по краям, не длиннее 31 символа, не пустое. */
export const xlsxSheetName = (name: string | undefined): string =>
    (name ?? '')
        .replace(/[[\]:*?/\\]/g, '_')
        .trim()
        .slice(0, SHEET_NAME_MAX)
        .replace(/^'+|'+$/g, '')
        .trim() || 'Данные';

/** Буквенное имя колонки листа по индексу с 0: 0 → A, 26 → AA. */
export const xlsxColumnName = (index: number): string =>
    (index >= 26 ? xlsxColumnName(Math.floor(index / 26) - 1) : '') + String.fromCharCode(65 + (index % 26));
